import { hideableLayoutContextMenuItems, hideableLayoutFunc } from './hideable-layout.js';

const dataLabelsConfig = {
	tagName: 'HideableLayout',
	withSwitch: true,
	key: 'dataLabelsHideableLayout',
	contextMenuItems: hideableLayoutContextMenuItems,
	func: hideableLayoutFunc,
	title: { desc: 'Sankey0', name: 'data labels' },
	children: [
		{
			tagName: 'Text',
			text: { desc: 'Sankey1', name: 'Label Alignment' }
		},
		{
			tagName: 'HorizontalLayout',
			className: 'two-to-one-layout',
			children: [
				{
					tagName: 'Text',
					className: 'format-select-text',
					text: { desc: 'Sankey2', name: 'Source' }
				},
				{
					tagName: 'Select',
					key: 'sourceLabelAlignment',
					className: 'sankey-viz-dropdown',
					innerClassName: 'sankey-label-alignment-icons',
					options: [
						{ name: { desc: 'Sankey28', name: 'Left Aligned' }, value: 'left' },
						{ name: { desc: 'Sankey29', name: 'Right Aligned' }, value: 'right' }
					],
					icons: ['left', 'right']
				}
			]
		},
		{
			tagName: 'HorizontalLayout',
			className: 'two-to-one-layout',
			children: [
				{
					tagName: 'Text',
					className: 'format-select-text',
					text: { desc: 'Sankey3', name: 'Waypoint' }
				},
				{
					tagName: 'Select',
					key: 'waypointLabelAlignment',
					className: 'sankey-viz-dropdown',
					innerClassName: 'sankey-label-alignment-icons',
					options: [
						{ name: { desc: 'Sankey28', name: 'Left Aligned' }, value: 'left' },
						{ name: { desc: 'Sankey29', name: 'Right Aligned' }, value: 'right' }
					],
					icons: ['left', 'right']
				}
			]
		},
		{
			tagName: 'HorizontalLayout',
			className: 'two-to-one-layout',
			children: [
				{
					tagName: 'Text',
					className: 'format-select-text',
					text: { desc: 'Sankey4', name: 'Target' }
				},
				{
					tagName: 'Select',
					key: 'targetLabelAlignment',
					className: 'sankey-viz-dropdown',
					innerClassName: 'sankey-label-alignment-icons',
					options: [
						{ name: { desc: 'Sankey28', name: 'Left Aligned' }, value: 'left' },
						{ name: { desc: 'Sankey29', name: 'Right Aligned' }, value: 'right' }
					],
					icons: ['left', 'right']
				}
			]
		},
		{
			tagName: 'Checkbox',
			checked: false,
			key: 'showLabelOnNode',
			className: 'sankey-viz-checkbox',
			text: { desc: 'Sankey5', name: 'Show label on node' }
		},
		{ tagName: 'Divider' }
	]
};

export default dataLabelsConfig;
